<template>
  <div class="box">
    <h4 class="title is-6">Recent Hotspots</h4>
    <table class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>Province</th>
          <th>Brightness</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="i in 5" :key="i">
          <td>Chiang Mai</td>
          <td>345</td>
          <td>2026-02-15</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
